import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Bot, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";

const PrivacyPage = () => {
  const { t } = useTranslation();
  const rawSections = t('legal.privacy.sections', { returnObjects: true });
  const sections = Array.isArray(rawSections) ? rawSections : [];

  return (
    <div className="min-h-screen bg-background">
      <SEO title={t('legal.privacy.title')} description={t('legal.privacy.meta')} canonical="/privacy" />

      {/* Nav */}
      <nav className="fixed top-0 left-0 right-0 z-40 glass">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <Bot className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading font-bold text-white">Stronger Bot</span>
          </Link>
          <Link to="/"><Button variant="ghost" className="text-slate-400 hover:text-white gap-2"><ArrowLeft className="w-4 h-4" />{t('legal.back')}</Button></Link>
        </div>
      </nav>

      <main className="pt-24 pb-20 px-4 max-w-3xl mx-auto">
        <h1 className="font-heading text-3xl font-bold text-white mb-2">{t('legal.privacy.title')}</h1>
        <p className="text-slate-400 text-sm mb-10">{t('legal.privacy.updated')}</p>

        {sections.map((s, i) => (
          <section key={i} className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-3">{s.title}</h2>
            <div className="text-slate-400 leading-relaxed space-y-2">
              {Array.isArray(s.content)
                ? s.content.map((c, j) => <p key={j}>{c}</p>)
                : <p>{s.content}</p>}
            </div>
          </section>
        ))}
      </main>

      <footer className="border-t border-white/5 py-8 text-center text-slate-400 text-sm">
        <p>{t('landing.footer')}</p>
        <div className="flex justify-center gap-6 mt-3">
          <Link to="/privacy" className="hover:text-white transition-colors">{t('legal.nav.privacy')}</Link>
          <Link to="/terms" className="hover:text-white transition-colors">{t('legal.nav.terms')}</Link>
          <Link to="/legal" className="hover:text-white transition-colors">{t('legal.nav.legal')}</Link>
        </div>
      </footer>
    </div>
  );
};
export default PrivacyPage;
